<table #table class="grid-table">
  @for (row of images | chunk:4; track row) {
    <tr>
      @for (image of row; track image) {
        <td cmGridCell [image]="image"></td>
      }
    </tr>
  }
</table>
